// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screenfull-svg[data-v-1d75d652]{display:inline-block;cursor:pointer;fill:#5a5e66;width:20px;height:20px;vertical-align:10px}", ""]);
// Exports
module.exports = exports;
